import { useNotificationStore } from '@/services/notificationService.ts'
import styles from './notifications.module.css'

export const Notifications = () => {
  const { notifications, removeNotification } = useNotificationStore()

  const handleKeyDown = (event: React.KeyboardEvent, id: number) => {
    if (event.key === 'Enter' || event.key === ' ') {
      removeNotification(id)
    }
  }

  return (
    <div className={styles.notificationsContainer}>
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`${styles.notification} ${styles[notification.type]} ${styles.slideIn}`}
          onClick={() => removeNotification(notification.id)}
          onKeyDown={(e) => handleKeyDown(e, notification.id)}
          role="alert"
          aria-label={`Notification: ${notification.message}`}
        >
          <div className={styles.message}>{notification.message}</div>
          <button
            type="button"
            className={styles.closeButton}
            onClick={(e) => {
              e.stopPropagation()
              removeNotification(notification.id)
            }}
            aria-label="Close notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )
}
